module.exports = __webpack_public_path__ + "static/media/signage-indoor-img67.449b151b.jpg";